<template>
    <vx-modal v-model:visible="mediaExpiredModal" size="lg">
        <template v-slot:header>
            <div class="flex flex-col items-center justify-center gap-y-2">
                <font-awesome-icon widthAuto :icon="faImage" size="2xl" class="text-rose-400" />
                <span class="text-3xl font-extrabold text-center">Expired Media</span>
            </div>
        </template>

        <div class="flex flex-col items-center justify-center gap-y-8">
            <p class="text-base font-normal text-center text-slate-500">
                Images and videos are only kept by our MMS provider for a short time. After this time, the media
                will disappear. Instead of deleting the message entirely, we show a placeholder icon so you can see
                when the media was sent or received.
            </p>
            <div class="flex items-center justify-center w-full">
                <vx-button
                    @click.prevent="mediaExpiredModal = false"
                    size="lg"
                    type="button"
                    block
                    color="primary"
                    class="lg:mt-6 max-w-[269px]"
                >
                    Got It
                </vx-button>
            </div>
        </div>
    </vx-modal>
</template>

<script setup>
import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { VxButton, VxModal } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const mediaExpiredModal = defineModel({
    type: Boolean,
    required: false,
    default: false,
});
</script>
